export default {
  install(Vue) {
    Vue.prototype.$isTouchDevice = ('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
  }
};